import BaseModel from 'src/model/base.model';

class CreditCardModel extends BaseModel {
  public id: string;
  public number: string;
  public type: string;
}

export default CreditCardModel;
